import moment from "moment-timezone";

export const getUtcOffsetFromTimezoneName = (timeZone) => {
  const timeZoneName = Intl.DateTimeFormat("ia", {
    timeZoneName: "shortOffset",
    timeZone,
  })
    .formatToParts()
    .find((i) => i.type === "timeZoneName").value;
  const offset = timeZoneName.slice(3);
  if (!offset) return 0;

  const matchData = offset.match(/([+-])(\d+)(?::(\d+))?/);
  if (!matchData)
    throw new Error(`cannot parse timezone name: ${timeZoneName}`);

  const [, sign, hour, minute] = matchData;
  let result = parseInt(hour) * 60;
  if (sign === "-") result *= -1;
  if (minute) result += parseInt(minute);

  return result;
};

export const rezoneMomentDateTime = (mDate, mTime, timezone) => {
  const dateFormat = "YYYY-MM-DD";
  const timeFormat = "HH:mm";
  const formattedDate = mDate.format(dateFormat);
  const formattedTime = mTime.format(timeFormat);
  return moment.tz(`${formattedDate} ${formattedTime}`, timezone);
};

/**
 * Gets the payment type display name from an order
 * @param {Object} order - Order object with paymentMethod field
 * @returns {string} - Payment type: "Card", "Apple Pay", "Google Pay", "Free", or "N/A"
 */
export const getPaymentType = (order) => {
  if (!order) {
    return "N/A";
  }

  const paymentMethod = order.paymentMethod;

  switch (paymentMethod) {
    case "APPLE":
      return "Apple Pay";
    case "GOOGLE":
      return "Google Pay";
    case "CARD":
      return "Card";
    case "FREE":
      return "Free";
    default:
      return "N/A";
  }
};
